import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'src/components/App/App';
// import reportWebVitals from 'src/reportWebVitals';
import { poller, devLogger } from 'src/common/utilities';
import { AcceptedDexValues } from 'src/common/constants';
import Preview3DApp from 'src/components/Preview3DApp/Preview3DApp';
declare const window: { EventBus: any };

// as suggested here https://github.com/facebook/create-react-app/issues/8909#issuecomment-660743379
// instead of an alias we are adding `"baseUrl": ".",` to tsconfig.json
// so we can link assets by starting with `src/` (which is similar to the way we use the `@` alias in the main prokect)

// wrapping <React.StrictMode> around the <App /> component is giving errors and
// adding a bug (switching between panels does not work) so we are not adding it for the moment

poller(
  () => {
    return typeof window.EventBus !== 'undefined';
  },
  () => {
    // this event can be used to render the application but also to destroy its children (if data.dex has a wrong value)
    window.EventBus.$on('renderDEX', (data: any) => {
      devLogger.log('DesignStack App render!', data);
      const dexRoot = ReactDOM.createRoot(
        document.getElementById('dex-root') as HTMLElement
      );
      const shouldRenderAppComponent = Object.values(AcceptedDexValues).includes(
        data.dex
      );
      // render the component if props are valid
      if (shouldRenderAppComponent) {
        dexRoot.render(
          <App dex={data.dex} dexData={data.dexData} locale={data.locale} />
        );
      } else {
        // destroy the element if props are not valid
        dexRoot.unmount();
      }
    });

    window.EventBus.$on('render3DPreview', (data: any) => {
      devLogger.log('3D Preview App render!', data);
      const shouldRenderAppComponent =
        data.elementId !== undefined &&
        data.mcpSku !== undefined &&
        data.skuVariables !== undefined &&
        data.cimDoc !== undefined;

      const htmlRootElement = document.getElementById(
        data.elementId
      ) as HTMLElement;
      if (htmlRootElement) {
        const previewRoot = ReactDOM.createRoot(htmlRootElement);
        if (previewRoot) {
          // render the component if props are valid
          if (shouldRenderAppComponent) {
            previewRoot.render(<Preview3DApp options={data} />);
          } else {
            // destroy the element if props are not valid
            previewRoot.unmount();
          }
        }
      }
    });

    devLogger.log('DesignStack Index wired to Vue EventBus!');
  }
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
